import React from "react";
import "./CampaignDetailsPage.css";
import CampaignDetails from "../../../components/common/campaigns/campaigndetails/CampaignDetails";
const CampaignDetailsPage = () => {
  return (
    <>
      <div className="campaign-details-page">
        <CampaignDetails />
      </div>
    </>
  );
};

export default CampaignDetailsPage;
